import { Store } from 'rxjs-observable-store';
import { ActiveVideo } from './models/active_video';
import * as i0 from "@angular/core";
export class VideoService extends Store {
    constructor() {
        super(new ActiveVideo());
    }
}
VideoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function VideoService_Factory() { return new VideoService(); }, token: VideoService, providedIn: "root" });
